import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '@env';
import { PersonaService, type Persona } from '@shared/service';

export function personaGuard(allowed: Persona[]): CanActivateFn {
  return () => {
    const personaSvc = inject(PersonaService);
    const router = inject(Router);
    let persona = personaSvc.currentPersona();
    if (!persona) {
      if (environment.skipAuth) {
        personaSvc.bootstrapDefaultPersona();
        persona = personaSvc.currentPersona();
      }
      if (!persona) {
        router.navigate(['/auth/login']);
        return false;
      }
    }
    if (!allowed.includes(persona)) {
      const home =
        persona === 'admin'    ? '/admin/overview'
        : persona === 'customer' ? '/customer/discover'
        : '/vendor/dashboard';
      router.navigate([home]);
      return false;
    }
    return true;
  };
}
